import { useTranslation } from "react-i18next";
import "./SwapText.css";

const LANGUAGES = ["en", "it"] as const;

type SwapTextProps = {
  tKey: string;
  className?: string;
};

/**
 * Renders a translated string while reserving the width of the widest
 * language, so switching languages crossfades in place instead of reflowing
 * the layout around it (the source of the header "flicker" on language change).
 * Every language is stacked in the same CSS grid cell; only the active one is
 * visible, but all of them still contribute to the box's intrinsic width.
 */
function SwapText({ tKey, className }: SwapTextProps) {
  const { t, i18n } = useTranslation();
  const active = i18n.language.startsWith("it") ? "it" : "en";

  return (
    <span className={className ? `swap-text ${className}` : "swap-text"}>
      {LANGUAGES.map((lng) => (
        <span
          key={lng}
          className="swap-text-layer"
          data-active={lng === active}
          aria-hidden={lng !== active}
        >
          {t(tKey, { lng })}
        </span>
      ))}
    </span>
  );
}

export default SwapText;
